import Layout from "Layout";
import { StoreProductCardtype } from "./type";
import StoreProductCard from "./component/productsCard";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import { toast } from "react-toastify";
import { API_URL } from "env";
import { Pagination } from "antd";
// @ts-ignore: Allow importing SCSS modules without type declarations
import 'pages/Store/store.scss';

const indicatorColorTemplate = [
    { indicator: "New", color: "bg-green-500" },
    { indicator: "Bestseller", color: "bg-yellow-500" },
    { indicator: "Hot", color: "bg-red-500" },
    { indicator: "Popular", color: "bg-blue-500" },
]

const platformColorTemplate = [
    { platform: "MT4", color: "bg-blue-500" },
    { platform: "MT5", color: "bg-green-500" },
    { platform: "cTrader", color: "bg-purple-500" },
]


const MainStorePage = () => {
    const { t ,i18n } = useTranslation();
    const [page, setPage] = useState(1);
    const [totalData, setTotalData] = useState(0);
    const [status, setStatus] = useState<'loading' | 'error' | 'success'>('loading');
    const [allProducts, setAllProducts] = useState<StoreProductCardtype[]>([]);
    const [purchasedToolIds, setPurchasedToolIds] = useState<Set<number>>(new Set());
    const [fillterPlatform, setFillterPlatform] = useState("all");
    
    const lang = i18n.language;

    const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user') || '{}') : null;

    async function fetchPurchasedToolIds(): Promise<Set<number>> {
        try {
            if (!user || !user.id) return new Set<number>();
            const response = await fetch(API_URL + `/api/v1/be/orders?status=paid&user_id=${user.id}&limit=0&type=tool`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token') || ''}`,
                },
            });
            const data = await response.json();
            if (data.status) {
                const toolIds = new Set<number>();
                data.data.items.forEach((order: any) => {
                    toolIds.add(order.tool_id);
                });
                setPurchasedToolIds(toolIds);
                return toolIds;
            } else {
                toast.error("Response not ok" + response.statusText);
                return new Set<number>();
            }
        }
        catch (error) {
            console.error("Failed to fetch purchased tool IDs:", error);
            return new Set<number>();
        }
    }

    // get product from api
    async function fetchProducts(pageNumber: number = 1) {
        try {
            setStatus('loading');
            const response = await fetch(API_URL + `/api/v1/be/tools${pageNumber ? `?page=${pageNumber}&limit=9${fillterPlatform == 'all' ? "" : `&platform=${fillterPlatform}`}` : ''}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token') || ''}`,
                },
            });
            const toolPurchared = await fetchPurchasedToolIds();
            const data = await response.json();
            
            if (data.status) {
                // map data to StoreProductCardtype
                setTotalData(data.data.total || 0);
                console.log('Data total',data.data.total)
                const mappedData: StoreProductCardtype[] = data.data.items.map((item: any) => ({
                    id: item.id,
                    image: item.image_url || "",
                    platform: item.platform,
                    indicator: item.indicator,
                    name: item.title && item.title[lang] ? item.title[lang] : 'No Title',
                    star: item.star,
                    review: item.review,
                    fileBot: item.file_bot_url || '',
                    description: item.subtitle && item.subtitle[lang] ? item.subtitle[lang] : 'No Description',
                    price: `$${item.price}`,
                    discount: item.price_discount ? `$${item.price_discount}` : undefined,
                    finalPrice: `$${item.price_finalize}`,
                    isPurcharsed: toolPurchared.has(item.id),
                }));
                
                setAllProducts(mappedData);
                setStatus('success');
            } else {
                toast.error("Response not ok" + response.statusText);
            }
        }
        catch (error) {
            toast.error("Failed to fetch products. Please try again later." + error);
        }
    }

    useEffect(() => {
        fetchProducts();
    }, []);
    useEffect(() => {
        fetchProducts(page);
    }, [page]);
    useEffect(() => {
        fetchProducts(1);
    }, [fillterPlatform]);

    return (
        <Layout>
            <Helmet>
                <title>{t('store_seo_title')}</title>
                <meta name="description" content={t('store_seo_desc')} />
                <link rel="canonical" href="/stores" />
                <meta name="keywords" content="Lumir Store, Trading Bots Automated Trading, MT4 Bots, MT5 Bots, cTrader Bots, Algorithmic Trading, Forex Tools, Crypto Trading Bots" />
                <meta property="og:title" content={t('store_seo_title')} />
                <meta property="og:description" content={t('store_seo_desc')} />
                <meta property="og:url" content="/stores" />
                <meta property="og:type" content="website" />
            </Helmet>
            <div className={`numerologist-product `}>
                <div className="w-full header-content flex justify-between px-3 product-header !mb-4 py-2">
                    <h2 className="text-lg font-semibold title-latest-product text-[var(--primary-color)]">{t('lastedTools')}</h2>
                </div>
            </div>
            <div className={`flex flex-col gap-4 p-4 items-center min-h-[90vh] store-container`}>

                {/* Available Products Section */}
                <div className={`w-full max-w-7xl  `}>

                    <div className="mb-2 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                        <div className="product-text">
                            {t('store_filter') || 'Filter'}
                        </div>
                        <div className="flex items-center gap-4">
                            <select
                                name={"platform"}
                                value={fillterPlatform}
                                onChange={(e) => setFillterPlatform(e.target.value)}
                                className={`border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500  store-container`}>
                                <option value="all">{t('store_all')}</option>
                                <option value="MT4">MetaTrader 4 (MT4)</option>
                                <option value="MT5">MetaTrader 5 (MT5)</option>
                                <option value="cTrader">cTrader</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div className={`grid md:grid-cols-1 grid-cols-2 lg:grid-cols-3  gap-6 w-full  store-container`}>
                    {status === 'loading' ? (
                        <div className="col-span-3 text-center text-gray-500">
                            Loading...
                        </div>
                    ) : status === 'error' ? (
                        <div className="col-span-3 text-center text-red-500">
                            Failed to load products. Please try again later.
                        </div>
                    ) :
                        (allProducts.length > 0) ? (
                            allProducts.map((product) => (
                                <StoreProductCard
                                    key={product.id}
                                    fileBot={product.fileBot}
                                    isPurchased={product.isPurcharsed || product.finalPrice === "$0"}
                                    {...product}
                                />
                            ))
                        ) : (
                            <div className="col-span-3 text-center text-gray-500">
                                No products found.
                            </div>
                        )
                    }
                    <Pagination
                        className="col-span-3 flex justify-center mt-4"
                        current={page}
                        pageSize={9}
                        total={totalData}
                        onChange={(page) => setPage(page)}
                    />
                </div>
            </div>

        </Layout >
    );
};

export default MainStorePage;